(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lookbook-item"] && !Shopify.designMode) return;
  try {
    const btns = document.querySelectorAll('.lookbook-item__btn')
  for(let btn of btns){
    btn.addEventListener('click', ()=>{
      console.log('parent:', btn.parentElement)
      btn.parentElement.classList.toggle('visible')

      // if(btn.parentElement.classList.contains('visible')){
      //   btn.innerHTML = 'vermenos'
      // }else{
      //   btn.innerHTML = 'mermais'
      // }
    })
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["skrey-countdown"] && !Shopify.designMode) return;
  try {
    class CountdownTimerBar extends HTMLElement {
    connectedCallback() {
      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;
      this.timerInterval = null;

      this.timerEl = this.querySelector('.timer');
      this.displayEl = this.querySelector('.timer-display');

      const rawDate = this.getAttribute('schema-datetime');
      let target;

      try {
        target = this.parseDate(rawDate);
      } catch (err) {
        // Invalid/misconfigured date: fail silently in the UI, warn in console for the merchant/dev.
        console.warn('[countdown-timer-bar] Invalid date, expected DD/MM/YYYY hh:mm:ss:', rawDate);
        this.remove();
        return;
      }

      if (this.isDateInPast(target)) {
        this.remove();
        return;
      }

      this.countdown = target.getTime();
      this.timerEl.hidden = false;
      this.startTimer();

      // Reveal after first tick so numbers aren't shown at 00:00:00:00 for a frame.
      requestAnimationFrame(() => this.classList.remove('hide-element'));
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    }

    parseDate(date) {
      // DD/MM/YYYY hh:mm:ss
      const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/(\d{4}) ([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;

      if (!date || !regex.test(date)) {
        throw new Error('Invalid date provided. Please follow the DD/MM/YYYY hh:mm:ss format.');
      }

      const [datePart, timePart] = date.split(' ');
      const [day, month, year] = datePart.split('/');
      const parsed = new Date(`${year}-${month}-${day}T${timePart}`);

      if (Number.isNaN(parsed.getTime())) {
        throw new Error('Invalid date provided.');
      }

      return parsed;
    }

    isDateInPast(date) {
      return date.getTime() < Date.now();
    }

    padWithLeadingZero(number) {
      return number < 10 ? `0${number}` : `${number}`;
    }

    startTimer() {
      const tick = () => {
        const distance = this.countdown - Date.now();

        const days = Math.max(Math.floor(distance / this.day), 0);
        const hours = Math.max(Math.floor((distance % this.day) / this.hour), 0);
        const minutes = Math.max(Math.floor((distance % this.hour) / this.minute), 0);
        const seconds = Math.max(Math.floor((distance % this.minute) / this.second), 0);

        this.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(days);
        this.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hours);
        this.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minutes);
        this.querySelector('.js-timer-seconds').textContent = this.padWithLeadingZero(seconds);

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(this.timerInterval);
          this.style.display = 'none';
        }
      };

      tick();
      this.timerInterval = setInterval(tick, this.second);
    }
  }

  if (!customElements.get('countdown-timer-bar')) {
    customElements.define('countdown-timer-bar', CountdownTimerBar);
  }
  } catch(e) { console.error(e); }
})();

})();
